import React from 'react'
import "./spinner.css"

export const Spinner = () => {
  return (
    <div className='spinner'></div>
  )
}
